import { connect } from "react-redux";
import get from "lodash/get";

import {
  getGeozones as onGetGeozones,
  createGeozones as onCreateGeozone,
  deleteGeozone as onDeleteGeozone,
  updateGeozone as onUpdateGeozone,
  selectGeozone as onSelectGeozone,
  addUnitToGeozone as onAddUnitToGeozone,
  deleteUnitToGeozone as onDeleteUnitToGeozone,
} from "../../actions/geozoneActions";

const mapStateToProps = (state) => ({
  geozonesDataState: state.geozones.dataState,
  geozoneCreateDataState: state.geozones.createDataState,
  geozoneDeleteDataState: state.geozones.deleteDataState,
  geozoneUpdateDataState: state.geozones.updateDataState,
  geozoneAddUnitDataState: state.geozones.addUnitDataState,
  geozoneRemoveUnitDataState: state.geozones.deleteUnitDataState,
  geozoneRequestPocess: get(state, ["geozones", "requestPocess"], false),
  geozones: get(state, ["geozones", "geozones"], []),
  tempGeozone: get(state, ["geozones", "tempGeozone"], null),
  createdId: get(state, ["geozones", "createdId"], null),
  selectGeozone: get(state, ["geozones", "selectGeozone"], null),
  geozonesErrors: get(state, ["geozones", "errors"], []),
});

const mapDispatchToProps = {
  onGetGeozones,
  onCreateGeozone,
  onDeleteGeozone,
  onUpdateGeozone,
  onSelectGeozone,
  onAddUnitToGeozone,
  onDeleteUnitToGeozone,
};

const withGeozones = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withGeozones };
